export const UNSUBSCRIBE_ADDRESS_REQUEST = 'UNSUBSCRIBE_ADDRESS_REQUEST';
export const unsubscribeAddressRequest = address => ({
  address,
  type: UNSUBSCRIBE_ADDRESS_REQUEST,
});
